<div class="row">
  <div class="reports-form-container">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Treatment Date</mat-label>
      <input matInput [matDatepicker]="picker" [(ngModel)]="date_time" placeholder="Choose date" autocomplete="off" readonly
      [max]="maxDate"/>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </div>
</div>
<div class="row tankmeal">
  <div class="row batchentry">
    <p>Treatment</p>
  </div>
  <div *ngIf="!responseLoader">
    <div class="adjust loader-container">
      <div class="loader2"></div>
    </div>
  </div>
  <div class="row eachcard" [ngClass]="{'eachcard' : pondsDetails_dropdown.length>2 }">
    <div class="row" *ngFor="let pondselect of pondsDetails_dropdown; let j = index;">
      <div class="row">
        <div class="buttons-div" *ngIf="j == 0 && noApplyAllPondsEditable" style="padding-bottom: 15px; padding-top: 30px">
          <div class="transactions-button-container" >
            <button class="transaction-submit-button" (click)="applyToAllPonds(j);">
              <span class="text"><img src="assets/images/New_Icons/applytoallpond.svg" class="applytoponds">Apply to all ponds</span>
            </button>
          </div>
        </div>
        <div class="col-xs-2 history-top" *ngIf="j >= 1"></div>
      </div>
      <div class="row">
        <form class="form-group">
          <div class="panel-body table-responsive mealscard">
            <table class="table table-bordered table-striped text-center" cellspacing=" 0" width="100%">
              <thead>
              <tr [ngClass]="{'autofillClass': pondselect.Autofill == true}">
                <th>{{pondselect.pond_name}}</th>
                <th>Treatment Name</th>
                <th style="width: 8%;">Quantity</th>
                <th>UOM</th>
                <th>Treatment Type</th>
                <th>Description</th>
                <th *ngIf="noCardDeleteEditable"><span (click)="removePond(j)"  title="Delete Pond"
                                                       class="deletebtn">x</span></th>
              </tr>
              <tr *ngFor="let row of pondselect.TreatmentLogs; let i = index;">
                <td *ngIf="noMealEditText"><span *ngIf="noAddIconEditable && i == 0" class="addbtnitemmaster"><i
                  (click)="addNewTreatmentButton(j)"
                  class="fa fa-plus"></i></span><span> {{i + 1}}</span></td>
                <td>
                  <select name="feedtype" [ngModelOptions]="{standalone: true}"
                          [(ngModel)]="row.treatment_item_id"
                          class="itemmasterdropdown" *ngIf="noTreatmentNameEditable"
                          (change)="treatmentNameById(i, j); getTreatmentNameIdsUomData(i, j); getTreatmentBusinessItemId(i, j); row.uom_id=undefined">
                    <option value=undefined>Select Treatment Name</option>
                    <option value="{{(name.id)}}" *ngFor="let name of treatmentNames">{{name.item_name}}</option>
                  </select>
                  <p
                    *ngIf="!noTreatmentNameEditable">{{pondsDetails_dropdown[j].TreatmentLogs[i].treatment_name ? pondsDetails_dropdown[j].TreatmentLogs[i].treatment_name : 'NA'}}</p>
                </td>
                <td>
                  <input type="text" name="ftypequantity" [ngModelOptions]="{standalone: true}"
                         [(ngModel)]="row.quantity" *ngIf="nogeedQtyEditable"
                         class="form-control" autocomplete="off" (keypress)="numberValidation($event)">
                  <p *ngIf="!nogeedQtyEditable">{{row.quantity ? row.quantity : 'NA'}}</p>
                </td>
                <td>
                  <select name="uom" [ngModelOptions]="{standalone: true}"
                          [(ngModel)]="row.uom_id" *ngIf="noUomEditable"
                          (change)="getUomNameByUomId(i, j, row.uom_id)" class="itemmasterdropdown">
                    <option value=undefined>Select UOM</option>
                    <option value="{{uom.id}}" *ngFor="let uom of row.itemUom">{{uom.name}}</option>
                  </select>
                  <p
                    *ngIf="!noUomEditable">{{pondsDetails_dropdown[j].TreatmentLogs[i].name ? pondsDetails_dropdown[j].TreatmentLogs[i].name : 'NA'}}</p>
                </td>
                <td>
                  <select name="treatmenttypeid" [ngModelOptions]="{standalone: true}"
                          [(ngModel)]="row.treatment_type_id" (change)="getTreatmentTypeNameById(i, j)"
                          *ngIf="noTreatmentTypeEditable" class="itemmasterdropdown">
                    <option value=undefined>Select Treatment Type</option>
                    <option value="{{ttypes.id}}" *ngFor="let ttypes of treatmentTypes">{{ttypes.name}}</option>
                  </select>
                  <p
                    *ngIf="!noTreatmentTypeEditable">{{pondsDetails_dropdown[j].TreatmentLogs[i].treatment_type_name ? pondsDetails_dropdown[j].TreatmentLogs[i].treatment_type_name : "NA"}}</p>
                </td>
                <td>
                  <textarea type="text" name="description" [ngModelOptions]="{standalone: true}"
                            [(ngModel)]="row.description" *ngIf="noDescEditable"
                            class="form-control" autocomplete="off"></textarea>
                  <p
                    *ngIf="!noDescEditable">{{row.description ? row.description : "NA"}}</p>
                </td>
                <td *ngIf="noMealDeleteIconEditable"><span (click)="removeObj(i,j)" class="delete-icon"  title="Delete Meal"><img
                  src="assets/images/New_Icons/delete-icon.svg"></span>
                </td>
              </tr>
              </thead>
            </table>
          </div>
        </form>
      </div>
      <!--      </div>-->
    </div>
  </div>
  <div class="row" *ngIf="editButton && submitButton">
    <div class="buttons-div edit-commit-button">
      <div class="transactions-button-container">
        <button class="transaction-submit-button" *ngIf="editButton" (click)="treatmentEditIcon()">
          <span class="editicon"><img src="../../../../../../assets/images/New_Icons/edit.svg"></span>
          <span class="text">Edit</span>
        </button>
      </div>
      <div class="transactions-button-container">
        <button class="transaction-submit-button commit-button"
                [ngClass]="!disableDownload && isCommitDisabled ? 'disbledCls' : ''" *ngIf="submitButton"
                (click)="addTreatment()">
          <span class="commiticon"><img src="../../../../../../assets/images/New_Icons/commit.svg"></span>
          <span class="text">Commit</span>
        </button>
      </div>
    </div>
  </div>
  <div class="buttons-div preview-button-block" *ngIf="previewButton" style="padding-bottom: 30px;">
    <div class="transactions-button-container">
      <button class="transaction-submit-button preview-button" (click)="priviewButton()">
        <span class="icon"><img src="../../../../../../assets/images/New_Icons/preview.svg"></span>
        <span class="text">Preview</span>
      </button>
    </div>
  </div>
</div>
<!--</form>-->
